import React from 'react';
import banner1 from './../../Asset/1920px.jpg';
import banner2 from './../../Asset/1512px.jpg';
import banner3 from './../../Asset/1280px.png';
import { Box, Grid, Typography, MenuItem, Select } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { BorderBottom } from '@mui/icons-material';
import { ReactComponent as DocumentIcon } from './../../Asset/Icons/DocumentIcon.svg';
import { ReactComponent as DocumentIcon1 } from './../../Asset/Icons/DocumentIcon1.svg';
import { ReactComponent as LineArea } from './../../Asset/Icons/LineArea.svg';
import { ReactComponent as GoldBadge } from './../../Asset/Icons/Badge.svg';
import { ReactComponent as Arrow } from './../../Asset/Icons/Arrows1.svg';
import { ReactComponent as India } from './../../Asset/india1.svg';
import RadarChartComponent from './RadarChart';
import RadarChartCoordinator from './RadarChartCoordinator';
import PieChartComponentGroupLeader from '../../Inputs/PieChartComponentGroupLeader';
import PieChartComponentCoordinator from '../../Inputs/PieChartComponentCoordinator';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Card, IconButton } from '@mui/material';
import configParam from '../../config';
const DashboardLayout = ({ iszoneleader, totalAuditscard, totalAuditscardgrp, groupLeaderChartData, totalScoresCoordinator, filteredDatagroupdata, totalScoresRadarCoordinator, isCoordinator,isWcmhead,isPlanthead, totalScoresCoord,
    groupCountCoordinator,
    zoneCountCoordinator, avarageAuditcard, pendingAuditcard, completedAuditcard, avarageAuditcardgrp, pendingAuditcardgrp, completedAuditcardgrp,
    totalPlants, isGroupLeader, firstName, lastName, latestMassFive,
    currentImageIndex,
    handleNextImage,
    handlePrevImage,
    // eliteData,
    eliteClubData, eliteZoneData,
    // eliteZoneCount,
    canAccessDashboard,
    groupNameInfo,
    handleYearChangePieCoord,
    handleMonthChangePieCoord,
    selectedYearPieCoord,
    selectedMonthPieCoord,
    overallAverageScore,
    eliteZoneCount,
    eliteClubCount,
    selectedYearRadar, setSelectedYearRadar, selectedMonthsRadar, setSelectedMonthsRadar, years,
    handleYearChangePieChartGroup,
    handleMonthChangePieChartGroup,
    selectedYearPieGroup,
    selectedMonthPieGroup,
    groupLeaderChartDataPie,
    groupRadarData,
    fetchGroupLeaderDataRadarchart,
    selectedYearGroupRadar,
    selectedMonthsGroupRadar,
    setSelectedYearGroupRadar,
    setSelectedMonthsGroupRadar,
    groupLeaderRole,
    zones
}) => {

    console.log("eliteClubDataeliteClubData", eliteClubData)
    console.log("eliteZoneDataeliteZoneData", eliteZoneData)

    console.log("totalScoresCoordinatorLayout", totalScoresCoordinator);
    console.log("totalAuditscard", totalAuditscard);
    const ApiURL = configParam.API_URL;
    // Calculate the total score and average score
    const { totalScore, count } = groupLeaderChartDataPie.reduce(
        (acc, zoneData) => {
            acc.totalScore += zoneData.total_score;
            acc.count += 1;
            return acc;
        },
        { totalScore: 0, count: 0 }
    );

    const averageScore = (totalScore / count).toFixed(1);


    // Calculate and round to 2 decimal places


    const { totalScoreCoo, countCoo } = totalScoresCoordinator.reduce(
        (acc, zoneData) => {
            // Convert averageScore to a number before adding it
            const score = parseFloat(zoneData.averageScore);

            // Check if the conversion was successful
            if (!isNaN(score)) {
                acc.totalScoreCoo += score;
                acc.countCoo += 1;
            }

            return acc;
        },
        { totalScoreCoo: 0, countCoo: 0 }
    );

    // Calculate the average score
    const averageScoreCoo = countCoo === 0 ? 0 : (totalScoreCoo / countCoo).toFixed(1);
    console.log("averageScore111", averageScoreCoo);



    const generateColor = (averageScore) => {
        if (averageScore >= 0 && averageScore <= 24.9) {
            return "#ED0530";
        } else if (averageScore >= 25 && averageScore <= 27.9) {
            return "#F46983";
        } else if (averageScore >= 28 && averageScore <= 29.9) {
            return "#FF7800";
        } else if (averageScore >= 29 && averageScore <= 30.9) {
            return "#FFAE66";
        } else if (averageScore >= 31 && averageScore <= 32.9) {
            return "#73C272";
        } else {
            return "#489547";
        }
    };


    return (
        <Box sx={{}}>
            <Box sx={{ position: 'relative', width: '100%'}}>
                <picture style={{ width: '100%' }}>
                    <source media="(min-width:1650px)" srcSet={banner1} />
                    <source media="(min-width:1300px)" srcSet={banner2} />
                    <img src={banner3} alt="Flowers" style={{ width: '100%' ,height:'100px',minHeight:'100px'}} />
                </picture>
                <Box sx={{ position: 'absolute', left: '0', top: '0', padding: '12px' }}>
                    <h2 style={{ color: '#fff', marginBottom: 0, marginTop: '10px', fontWeight: '600' }}>Hi {firstName} {lastName}, Good Morning!</h2>
                    {/* <p style={{ color: '#fff', fontSize: '14px', maxWidth: '800px', lineHeight: '21px' }}>Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p> */}
                </Box>
            </Box>
            {!canAccessDashboard && (
                <>
                    <Grid container sx={{ width: '100%', padding: '16px' }}>
                        {!isGroupLeader && (
                            <Grid item xs={12} md={8}>
                                <Box sx={{ border: '1px solid #ccc', borderRadius: '5px', width: '100%' }}>
                                    <Box sx={{ borderBottom: '1px solid #ccc', padding: '12px' }}>
                                        <Typography variant='h4' sx={{ color: '#17428B', fontSize: '16px', fontWeight: '600' }}>6S Audit Summary - India</Typography>
                                    </Box>
                                    <Box>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={4} sx={{ margin: '12px 0', textAlign: 'center' }}>
                                                <India />
                                            </Grid>
                                            <Grid item xs={12} md={8}>
                                                <Grid container spacing={2} sx={{ padding: '12px' }}>
                                                    <Grid item xs={4} sx={{ margin: '12px 0' }}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                            <DocumentIcon1 />
                                                            <Typography sx={{ fontSize: '14px', color: '#616161' }}>Overall Score</Typography>
                                                        </Box>
                                                        <Box><Typography variant='h3' sx={{ fontSize: '34px', width: '100%', fontWeight: 'bold', textAlign: 'center', margin: '12px 0' }}>{totalScoresCoord}</Typography></Box>
                                                        <Box>
                                                            <Typography sx={{ fontSize: '12px', textAlign: 'center' }}>
                                                                {/* <Typography variant='span'>+3</Typography> Vs Last Year */}
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={4} sx={{ margin: '12px 0' }}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                            <DocumentIcon />
                                                            <Typography sx={{ fontSize: '14px', color: '#616161' }}>Total plants</Typography>
                                                        </Box>
                                                        <Box><Typography variant='h3' sx={{ fontSize: '34px', width: '100%', fontWeight: 'bold', textAlign: 'center', margin: '12px 0' }}>{totalPlants}</Typography></Box>
                                                        <Box>
                                                            <Typography sx={{ fontSize: '12px', textAlign: 'center' }}>
                                                                {/* <Typography variant='span'>+3</Typography> Vs Last Year */}
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={4} sx={{ margin: '12px 0' }}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                            <DocumentIcon />
                                                            <Typography sx={{ fontSize: '14px', color: '#616161' }}>Total Groups</Typography>
                                                        </Box>
                                                        <Box><Typography variant='h3' sx={{ fontSize: '34px', width: '100%', fontWeight: 'bold', textAlign: 'center', margin: '12px 0' }}>{groupCountCoordinator}</Typography></Box>
                                                        <Box>
                                                            <Typography sx={{ fontSize: '12px', textAlign: 'center' }}>
                                                                {/* <Typography variant='span'>+3</Typography> Vs Last Year */}
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={4} sx={{ margin: '12px 0' }}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                            <DocumentIcon />
                                                            <Typography sx={{ fontSize: '14px', color: '#616161' }}>Total Zones</Typography>
                                                        </Box>
                                                        <Box><Typography variant='h3' sx={{ fontSize: '34px', width: '100%', fontWeight: 'bold', textAlign: 'center', margin: '12px 0' }}>{zoneCountCoordinator}</Typography></Box>
                                                        <Box>
                                                            <Typography sx={{ fontSize: '12px', textAlign: 'center' }}>
                                                                {/* <Typography variant='span'>+3</Typography> Vs Last Year */}
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={4} sx={{ margin: '12px 0' }}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                            <DocumentIcon />
                                                            <Typography sx={{ fontSize: '14px', color: '#616161' }}>Elite Club</Typography>
                                                        </Box>
                                                        <Box><Typography variant='h3' sx={{ fontSize: '34px', width: '100%', fontWeight: 'bold', textAlign: 'center', margin: '12px 0' }}>{eliteClubCount}</Typography></Box>
                                                        <Box>
                                                            <Typography sx={{ fontSize: '12px', textAlign: 'center' }}>
                                                                {/* <Typography variant='span'>+3</Typography> Vs Last Year */}
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={4} sx={{ margin: '12px 0' }}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                            <DocumentIcon />
                                                            <Typography sx={{ fontSize: '14px', color: '#616161' }}>Elite Zones</Typography>
                                                        </Box>
                                                        <Box><Typography variant='h3' sx={{ fontSize: '34px', width: '100%', fontWeight: 'bold', textAlign: 'center', margin: '12px 0' }}>{eliteZoneCount}</Typography></Box>
                                                        <Box>
                                                            <Typography sx={{ fontSize: '12px', textAlign: 'center' }}>
                                                                {/* <Typography variant='span'>+3</Typography> Vs Last Year */}
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Box>
                            </Grid>
                        )}
                        {(isCoordinator || isWcmhead||isPlanthead)&& (
                            <Grid item xs={12} md={4} sx={{
                                paddingLeft: {
                                    md: '16px', xs: '0'
                                }, marginTop: { md: '0', xs: '12px' }
                            }}>
                                <Box sx={{ border: '1px solid #ccc', borderRadius: '5px', width: '100%' }}>
                                    <Box sx={{ borderBottom: '1px solid #ccc', padding: '12px' }}>
                                        <Typography variant='h4' sx={{ color: '#17428B', fontSize: '16px', fontWeight: '600' }}>Mass 5S Activities</Typography>
                                    </Box>
                                    <Box sx={{ padding: '12px' }}>
                                        {latestMassFive.length > 0 && (
                                            <Box
                                                sx={{
                                                    position: "relative",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    padding: '16px',
                                                    height: '285px'
                                                }}
                                            >
                                                <img
                                                    src={`${ApiURL}/api/imagesMass/${latestMassFive[currentImageIndex].img_bef[latestMassFive[currentImageIndex].img_bef.length - 1]}`}
                                                    alt="Mass Five"
                                                    style={{
                                                        maxWidth: "100%",
                                                        maxHeight: '100%',
                                                        position: 'absolute',
                                                        left: '0',
                                                        right: '0',
                                                        top: '0',
                                                        bottom: '0',
                                                        margin: 'auto'
                                                    }}
                                                />
                                                <IconButton
                                                    onClick={handlePrevImage}
                                                    sx={{
                                                        position: "absolute",
                                                        left: 10,
                                                        top: "50%",
                                                        transform: "translateY(-50%)",
                                                        zIndex: 10,
                                                    }}
                                                >
                                                    <ArrowBackIcon />
                                                </IconButton>
                                                <IconButton
                                                    onClick={handleNextImage}
                                                    sx={{
                                                        position: "absolute",
                                                        right: 10,
                                                        top: "50%",
                                                        transform: "translateY(-50%)",
                                                        zIndex: 10,
                                                    }}
                                                >
                                                    <ArrowForwardIcon />
                                                </IconButton>
                                            </Box>
                                        )}
                                    </Box>
                                </Box>
                            </Grid>
                        )}
                    </Grid>
                    <Box sx={{ padding: '16px' }}>
                        <Typography variant='h4' sx={{ color: '#17428B', fontSize: '16px', fontWeight: '600' }}>Audit Summary - {(isCoordinator||isWcmhead||isPlanthead) ? ' WCM Co-ordinator - Plant Name' : `Group Name: ${groupNameInfo}`}</Typography>
                    </Box>
                    <Grid container sx={{ padding: '0 8px 16px' }}>
                        <Grid item md={3} sm={6} xs={12}>
                            <Box sx={{ border: '1px solid #ccc', borderRadius: '5px', padding: '12px', margin: '8px' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <Typography sx={{ fontSize: '14px', color: '#616161' }}>Total Audits</Typography>
                                    <DocumentIcon />
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    {/* <Typography variant='h3' sx={{ fontSize: '34px', width: '100%', fontWeight: 'bold', textAlign: 'left', margin: '12px 0' }}>{isCoordinator && {}}{!isCoordinator && {totalAuditscardgrp}}</Typography> */}
                                    <Typography
                                        variant="h3"
                                        sx={{
                                            fontSize: '34px',
                                            width: '100%',
                                            fontWeight: 'bold',
                                            textAlign: 'left',
                                            margin: '12px 0'
                                        }}
                                    >
                                        {(isCoordinator||isWcmhead||isPlanthead) ? totalAuditscard : totalAuditscardgrp}
                                    </Typography>
                                    <LineArea width={100} />
                                </Box>
                                <Box>
                                    <Typography sx={{ fontSize: '12px', textAlign: 'right' }}>
                                        {/* <Typography variant='span'>+3</Typography> Vs Last Year */}
                                    </Typography>
                                </Box>
                            </Box>

                        </Grid>
                        <Grid item md={3} sm={6} xs={12}>
                            <Box sx={{ border: '1px solid #ccc', borderRadius: '5px', padding: '12px', margin: '8px' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <Typography sx={{ fontSize: '14px', color: '#616161' }}>Completed Audits</Typography>
                                    <DocumentIcon />
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    {/* <Typography variant='h3' sx={{ fontSize: '34px', width: '100%', fontWeight: 'bold', textAlign: 'left', margin: '12px 0' }}>{isCoordinator && {}}{!isCoordinator && {completedAuditcardgrp}}</Typography> */}
                                    <Typography
                                        variant="h3"
                                        sx={{
                                            fontSize: '34px',
                                            width: '100%',
                                            fontWeight: 'bold',
                                            textAlign: 'left',
                                            margin: '12px 0'
                                        }}
                                    >
                                        {(isCoordinator||isWcmhead||isPlanthead) ? completedAuditcard : completedAuditcardgrp}
                                    </Typography>
                                    <LineArea width={100} />
                                </Box>
                                <Box>
                                    <Typography sx={{ fontSize: '12px', textAlign: 'right' }}>
                                        {/* <Typography variant='span'>+3</Typography> Vs Last Year */}
                                    </Typography>
                                </Box>
                            </Box>

                        </Grid>
                        <Grid item md={3} sm={6} xs={12}>
                            <Box sx={{ border: '1px solid #ccc', borderRadius: '5px', padding: '12px', margin: '8px' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <Typography sx={{ fontSize: '14px', color: '#616161' }}>Pending Audits</Typography>
                                    <DocumentIcon />
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <Typography
                                        variant="h3"
                                        sx={{
                                            fontSize: '34px',
                                            width: '100%',
                                            fontWeight: 'bold',
                                            textAlign: 'left',
                                            margin: '12px 0'
                                        }}
                                    >
                                        {(isCoordinator||isWcmhead||isPlanthead) ? pendingAuditcard : pendingAuditcardgrp}
                                    </Typography>
                                    <LineArea width={100} />
                                </Box>
                                <Box>
                                    <Typography sx={{ fontSize: '12px', textAlign: 'right' }}>
                                        {/* <Typography variant='span'>+3</Typography> Vs Last Year */}
                                    </Typography>
                                </Box>
                            </Box>

                        </Grid>

                        <Grid item md={3} sm={6} xs={12}>
                            <Box sx={{ border: '1px solid #ccc', borderRadius: '5px', padding: '12px', margin: '8px' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <Typography sx={{ fontSize: '14px', color: '#616161' }}>Total Score (YTD)</Typography>
                                    <DocumentIcon />
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <Typography
                                        variant="h3"
                                        sx={{
                                            fontSize: '34px',
                                            width: '100%',
                                            fontWeight: 'bold',
                                            textAlign: 'left',
                                            margin: '12px 0'
                                        }}
                                    >
                                        {(isCoordinator||isWcmhead||isPlanthead) ? avarageAuditcard : avarageAuditcardgrp}
                                    </Typography>
                                    <LineArea width={100} />
                                </Box>
                                <Box>
                                    <Typography sx={{ fontSize: '12px', textAlign: 'right' }}>
                                        {/* <Typography variant='span'>+3</Typography> Vs Last Year */}
                                    </Typography>
                                </Box>
                            </Box>

                        </Grid>
                    </Grid>
                    <Grid container sx={{ width: '100%', padding: '0 16px' }}>
                        <Grid item xs={12} md={7}>
                            {!isCoordinator && !isWcmhead && !isPlanthead &&(
                                <RadarChartComponent 
                                // groupLeaderChartData={groupLeaderChartData} 

                                groupRadarData={groupRadarData}
                                fetchGroupLeaderDataRadarchart={fetchGroupLeaderDataRadarchart}
                                selectedYearGroupRadar={selectedYearGroupRadar}
                                selectedMonthsGroupRadar={selectedMonthsGroupRadar}
                                setSelectedYearGroupRadar={setSelectedYearGroupRadar}
                                setSelectedMonthsGroupRadar={setSelectedMonthsGroupRadar}
                                groupLeaderRole={groupLeaderRole} 
                                years={years}
                                zones={zones}
                                />
                            )}
                            {(isCoordinator||isWcmhead||isPlanthead) && (
                                <RadarChartCoordinator

                                    totalScoresRadarCoordinator={totalScoresRadarCoordinator}
                                    selectedYearRadar={selectedYearRadar}
                                    setSelectedYearRadar={setSelectedYearRadar}
                                    selectedMonthsRadar={selectedMonthsRadar}
                                    setSelectedMonthsRadar={setSelectedMonthsRadar}
                                    years={years}

                                />
                            )}
                        </Grid >
                        <Grid sx={{
                            paddingLeft: {
                                xs: 0, md: '16px'
                            },
                            marginTop: {
                                xs: '16px', md: '0'
                            }
                        }} item xs={12} md={5}>
                            <Box sx={{ border: '1px solid #ccc', borderRadius: '5px', width: '100%', marginBottom: '16px' }}>
                                <Box sx={{ borderBottom: '1px solid #ccc', padding: '12px' }}>
                                    <Typography variant='h4' sx={{ color: '#17428B', fontSize: '16px', fontWeight: '600' }}>Audit Score Trend</Typography>
                                </Box>

                                <Box sx={{ width: '100%', display: 'flex' }}>
                                    <Box sx={{ width: '40%', padding: '16px' }}>
                                        <Box sx={{ height: '100%', display: 'flex', justifyContent: 'space-between', flexDirection: 'column' }}>
                                            <Box>
                                                <Box sx={{ display: 'flex' }}>
                                                    <Typography sx={{ fontSize: '14px', color: '#AFAFAF', fontWeight: '500' }}>Total Group Score</Typography>
                                                </Box>
                                                <Box>
                                                    <Typography
                                                        variant="h3"
                                                        sx={{
                                                            fontSize: '34px',
                                                            width: '100%',
                                                            fontWeight: 'bold',
                                                            textAlign: 'left',
                                                            margin: '12px 0'
                                                        }}
                                                    >
                                                        {/* {isCoordinator ? averageScoreCoo : averageScore}
                                                 */}
                                                        {(isCoordinator||isWcmhead||isPlanthead) ? overallAverageScore : averageScore}
                                                    </Typography>


                                                </Box>
                                                <Box>
                                                    <Typography sx={{ fontSize: '12px' }}>
                                                        {/* <Typography variant='span'>+3</Typography> Vs Last Year */}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            <Box sx={{ marginTop: '16px' }}>

                                                {!isCoordinator && !isWcmhead && !isPlanthead && groupLeaderChartData.map((zoneData) => (

                                                    <Box
                                                        key={zoneData.zone_name}
                                                        sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px', width: '100%' }}
                                                    >
                                                        <Box sx={{
                                                            display: 'flex', alignItems: 'center', width: '100%', textOverflow: 'ellipsis',
                                                            overflow: 'hidden',
                                                            whiteSpace: 'nowrap',
                                                        }}>
                                                            <Box sx={{ width: '5px', height: '10px', borderRadius: '3px', background: generateColor(zoneData.total_score) }}></Box>
                                                            <Typography
                                                                sx={{
                                                                    paddingRight: '16px',
                                                                    fontSize: '10px',
                                                                    color: '#878787',
                                                                    textOverflow: 'ellipsis',
                                                                    overflow: 'hidden',
                                                                    whiteSpace: 'nowrap',
                                                                    paddingLeft: '8px',
                                                                    width: '100%'
                                                                }}
                                                            >
                                                                {zoneData.zone_name}
                                                            </Typography>
                                                        </Box>
                                                        <Typography
                                                            sx={{
                                                                fontSize: '10px',
                                                                color: '#333'
                                                            }}
                                                        >
                                                            {zoneData.total_score}
                                                        </Typography>
                                                    </Box>
                                                ))}

                                                {(isCoordinator||isWcmhead||isPlanthead) && totalScoresCoordinator.map((groupName) => (
                                                    <Box
                                                        key={groupName.zone_name}
                                                        sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}
                                                    >
                                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                            <Box sx={{ width: '5px', height: '10px', borderRadius: '3px', background: generateColor(groupName.averageScore) }}></Box>
                                                            <Typography
                                                                sx={{
                                                                    paddingRight: '16px',
                                                                    fontSize: '10px',
                                                                    color: '#878787',
                                                                    textOverflow: 'ellipsis',
                                                                    overflow: 'hidden',
                                                                    whiteSpace: 'nowrap',
                                                                    paddingLeft: '8px'
                                                                }}
                                                            >
                                                                {groupName.groupName}
                                                            </Typography>
                                                        </Box>
                                                        <Typography
                                                            sx={{
                                                                fontSize: '10px',
                                                                color: '#333'
                                                            }}
                                                        >
                                                            {groupName.averageScore}
                                                        </Typography>
                                                    </Box>
                                                ))}

                                            </Box>
                                        </Box>
                                    </Box >
                                    <Box sx={{ width: '60%', overflow: 'hidden', padding: '12px 0' }}>
                                        {!isCoordinator && !isWcmhead && !isPlanthead && (
                                            <>
                                              <Box display="flex" alignItems="center" sx={{ padding: '4px 0 4px 0', gap: '4px', flexWrap: 'nowrap', overflow: 'hidden' }}>
                                            <Select
                                                        value={selectedYearPieGroup}
                                                        onChange={handleYearChangePieChartGroup}
                                                        sx={{
                                                            height: "32px",
                                                            fontSize: "14px",
                                                            padding: "4px 0px",
                                                            minWidth: "75px",
                                                            width: "auto",
                                                            flexShrink: 0, // Prevents shrinking
                                                          }}
                                              
                                                    >
                                                       
                                                         {years.map((year) => (
                        <MenuItem key={year} value={year}>
                            {year}
                        </MenuItem>
                    ))}
                                                    </Select>
                                                    <Select
                                                        value={selectedMonthPieGroup}
                                                        onChange={handleMonthChangePieChartGroup}
                                                        sx={{
                                                            height: "32px",
                                                            fontSize: "14px",
                                                            padding: "4px 0px",
                                                            minWidth: "100px",
                                                            width: "auto",
                                                            flexShrink: 0, // Prevents shrinking
                                                          }}
                                                    >
                                                        {Array.from({ length: 12 }, (_, i) => (
                                                            <MenuItem key={i + 1} value={i + 1}>
                                                                {new Date(0, i).toLocaleString('default', { month: 'long' })}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                            </Box>
                                             <PieChartComponentGroupLeader groupLeaderChartDataPie={groupLeaderChartDataPie} />
                                             </>
                                        )}
                                        {(isCoordinator||isWcmhead ||isPlanthead) && (
                                            <>
                                                <Box display="flex" alignItems="center" sx={{ padding: '4px 0 4px 0', gap: '4px', flexWrap: 'nowrap', overflow: 'hidden' }}>
                                                   
                                                    <Select
                                                        value={selectedYearPieCoord}
                                                        onChange={handleYearChangePieCoord}
                                                        sx={{
                                                            height: "32px",
                                                            fontSize: "14px",
                                                            padding: "4px 0px",
                                                            minWidth: "75px",
                                                            width: "auto",
                                                            flexShrink: 0, // Prevents shrinking
                                                          }}
                                              
                                                    >
                                                                                      {years.map((year) => (
                        <MenuItem key={year} value={year}>
                            {year}
                        </MenuItem>
                    ))}
                                                    </Select>
                                                    <Select
                                                        value={selectedMonthPieCoord}
                                                        onChange={handleMonthChangePieCoord}
                                                        sx={{
                                                            height: "32px",
                                                            fontSize: "14px",
                                                            padding: "4px 0px",
                                                            minWidth: "100px",
                                                            width: "auto",
                                                            flexShrink: 0, // Prevents shrinking
                                                          }}
                                                    >
                                                        {Array.from({ length: 12 }, (_, i) => (
                                                            <MenuItem key={i + 1} value={i + 1}>
                                                                {new Date(0, i).toLocaleString('default', { month: 'long' })}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </Box>

                                                <PieChartComponentCoordinator totalScoresCoordinator={totalScoresCoordinator} />
                                            </>
                                        )}
                                    </Box>
                                </Box >
                            </Box >
                            {isGroupLeader && (
                                <Box sx={{ border: '1px solid #ccc', borderRadius: '5px', width: '100%' }}>
                                    <Box sx={{ borderBottom: '1px solid #ccc', padding: '12px' }}>
                                        <Typography variant='h4' sx={{ color: '#17428B', fontSize: '16px', fontWeight: '600' }}>Mass 5S Activities</Typography>
                                    </Box>
                                    <Box sx={{ padding: '12px' }}>
                                        {latestMassFive.length > 0 && (
                                            <Box
                                                sx={{
                                                    position: "relative",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    padding: '16px',
                                                    height: '285px'
                                                }}
                                            >
                                                <img
                                                    src={`${ApiURL}/api/imagesMass/${latestMassFive[currentImageIndex].img_bef[latestMassFive[currentImageIndex].img_bef.length - 1]}`}
                                                    alt="Mass Five"
                                                    style={{
                                                        maxWidth: "100%",
                                                        maxHeight: '100%',
                                                        position: 'absolute',
                                                        left: '0',
                                                        right: '0',
                                                        top: '0',
                                                        bottom: '0',
                                                        margin: 'auto'
                                                    }}
                                                />
                                                <IconButton
                                                    onClick={handlePrevImage}
                                                    sx={{
                                                        position: "absolute",
                                                        left: 10,
                                                        top: "50%",
                                                        transform: "translateY(-50%)",
                                                        zIndex: 10,
                                                    }}
                                                >
                                                    <ArrowBackIcon />
                                                </IconButton>
                                                <IconButton
                                                    onClick={handleNextImage}
                                                    sx={{
                                                        position: "absolute",
                                                        right: 10,
                                                        top: "50%",
                                                        transform: "translateY(-50%)",
                                                        zIndex: 10,
                                                    }}
                                                >
                                                    <ArrowForwardIcon />
                                                </IconButton>
                                            </Box>
                                        )}
                                    </Box>
                                </Box>
                            )}
                            {(isCoordinator||isWcmhead||isPlanthead) && (
                                <Box sx={{ background: "#fff" }}>
                                    {eliteClubData.length > 0 && (
                                        <Box sx={{ border: "1px solid #ccc", borderRadius: "5px", width: "100%" }}>
                                            <Box sx={{ padding: "12px" }}>
                                                <Typography variant="h4" sx={{ color: "#17428B", fontSize: "16px", fontWeight: "600" }}>
                                                    Elite Club
                                                </Typography>
                                            </Box>
                                            {eliteClubData.map((item, index) => (
                                                <Box key={index} sx={{ border: "1px solid #ccc", borderRadius: "5px", width: "100%" }}>
                                                    <Box sx={{ display: "flex", alignItems: "center", padding: "12px" }}>
                                                        <DocumentIcon1 />
                                                        <GoldBadge style={{ margin: "0 12px" }} />
                                                        <Box>
                                                            <Typography variant="h6" sx={{ color: "#17428B", fontSize: "14px", fontWeight: "600" }}>
                                                                Zone: {item.name}
                                                            </Typography>
                                                            <Typography variant="body2" sx={{ color: "#B8B8B8", fontSize: "12px" }}>
                                                                Zone Code: {item.code}
                                                            </Typography>
                                                            <Typography variant="body2" sx={{ color: "#B8B8B8", fontSize: "12px" }}>
                                                                Group Leader: {item.group_leader_name}
                                                            </Typography>
                                                            <Typography variant="body2" sx={{ color: "#B8B8B8", fontSize: "12px" }}>
                                                                Zone Leader: {item.zone_leader_name}
                                                            </Typography>
                                                            <Typography variant="body2" sx={{ color: "#B8B8B8", fontSize: "12px" }}>
                                                                Average Score: {item.total12monthspoints}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            ))}
                                        </Box>
                                    )}

                                    {eliteZoneData.length > 0 && (
                                        <Box sx={{ border: "1px solid #ccc", borderRadius: "5px", width: "100%" }}>
                                            <Box sx={{ padding: "12px" }}>
                                                <Typography variant="h4" sx={{ color: "#17428B", fontSize: "16px", fontWeight: "600" }}>
                                                    Elite Zones
                                                </Typography>
                                            </Box>
                                            {eliteZoneData.map((item, index) => (
                                                <Box key={index} sx={{ border: "1px solid #ccc", borderRadius: "5px", width: "100%" }}>
                                                    <Box sx={{ display: "flex", alignItems: "center", padding: "12px" }}>
                                                        <DocumentIcon1 />
                                                        <GoldBadge style={{ margin: "0 12px" }} />
                                                        <Box>
                                                            <Typography variant="h6" sx={{ color: "#17428B", fontSize: "14px", fontWeight: "600" }}>
                                                                Zone: {item.name}
                                                            </Typography>
                                                            <Typography variant="body2" sx={{ color: "#B8B8B8", fontSize: "12px" }}>
                                                                Zone Code: {item.code}
                                                            </Typography>
                                                            <Typography variant="body2" sx={{ color: "#B8B8B8", fontSize: "12px" }}>
                                                                Group Leader: {item.group_leader_name}
                                                            </Typography>
                                                            <Typography variant="body2" sx={{ color: "#B8B8B8", fontSize: "12px" }}>
                                                                Zone Leader: {item.zone_leader_name}
                                                            </Typography>
                                                            <Typography variant="body2" sx={{ color: "#B8B8B8", fontSize: "12px" }}>
                                                                Selected Month Score: {item.selected_month_score}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            ))}
                                        </Box>
                                    )}
                                </Box>


                                //                 <Box sx={{ border: '1px solid #ccc', borderRadius: '5px', width: '100%' }}>
                                //                     <Box sx={{ padding: '12px' }}>
                                //                         <Typography variant='h4' sx={{ color: '#17428B', fontSize: '16px', fontWeight: '600' }}>Elite Zones</Typography>
                                //                     </Box>
                                //                 {eliteData.length > 0 ? (
                                //     eliteData.map((item, index) => (
                                //         <Box sx={{ 
                                //             border: '1px solid #ccc', 
                                //             borderRadius: '5px', 
                                //             width: '100%', 
                                //             position: 'relative', // Allows absolute positioning of the arrow icon
                                //         }}>
                                //             {/* Arrow icon positioned at the top right */}
                                //             <Box sx={{ 
                                //                 position: 'absolute', 
                                //                 top: '12px', 
                                //                 right: '12px' 
                                //             }}>
                                //                 <Arrow />
                                //             </Box>

                                //             <Box sx={{ display: 'flex', alignItems: 'center', padding: '12px' }}>
                                //                 <DocumentIcon1 />
                                //                 <GoldBadge style={{ margin: '0 12px' }} />

                                //                 {/* Main content container */}
                                //                 <Box>
                                //                     <Typography variant="h6" sx={{ 
                                //                         color: '#17428B', 
                                //                         fontSize: '14px', 
                                //                         fontWeight: '600', 
                                //                         margin: '0', 
                                //                         lineHeight: '17px' 
                                //                     }}>
                                //                         Zone: {item.name}
                                //                     </Typography>

                                //                     <Typography variant="body2" sx={{ 
                                //                         color: '#B8B8B8', 
                                //                         fontSize: '12px', 
                                //                         display: 'block'  // Ensures each Typography appears on its own line
                                //                     }}>
                                //                         Zone Code: {item.code}
                                //                     </Typography>

                                //                     <Typography variant="body2" sx={{ 
                                //                         color: '#B8B8B8', 
                                //                         fontSize: '12px', 
                                //                         display: 'block' 
                                //                     }}>
                                //                         Group Leader: {item.group_leader_name}
                                //                     </Typography>

                                //                     <Typography variant="body2" sx={{ 
                                //                         color: '#B8B8B8', 
                                //                         fontSize: '12px', 
                                //                         display: 'block' 
                                //                     }}>
                                //                         Zone Leader: {item.zone_leader_name}
                                //                     </Typography>

                                //                     <Typography variant="body2" sx={{ 
                                //                         color: '#B8B8B8', 
                                //                         fontSize: '12px', 
                                //                         display: 'block' 
                                //                     }}>
                                //                         Selected Month Score: {item.selected_month_score}
                                //                     </Typography>
                                //                 </Box>
                                //             </Box>
                                //         </Box>

                                //         // <Box key={index} sx={{ borderTop: '1px solid #ccc', width: '100%', padding: '12px' }}>
                                //         //     <Typography variant="h6" sx={{ fontSize: 16, marginBottom: 1 }}>
                                //         //         Zone: {item.name}
                                //         //     </Typography>
                                //         //     <Typography sx={{ fontWeight: 400, fontSize: 12, color: '#666' }}>
                                //         //         Zone Code: {item.code}
                                //         //     </Typography>
                                //         //     <Typography sx={{ fontWeight: 400, fontSize: 12, color: '#666' }}>
                                //         //         Group Leader: {item.grp_first} {item.grplast}
                                //         //     </Typography>
                                //         //     <Typography sx={{ fontWeight: 400, fontSize: 12, color: '#666' }}>
                                //         //         Zone Leader: {item.zone_first} {item.zonelast}
                                //         //     </Typography>
                                //         //     <div style={{ marginTop: '10px', paddingTop: '10px', borderTop: '1px solid #ddd' }}>
                                //         //         <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#555' }}>
                                //         //             Scores:
                                //         //         </Typography>
                                //         //         <Typography sx={{ fontWeight: 400, fontSize: 12, color: '#666' }}>
                                //         //             Selected Month: {item.selected_month_score}
                                //         //         </Typography>

                                //         //     </div>
                                //         // </Box>
                                //     ))
                                // ) : (
                                //     <Typography sx={{ padding: '12px', color: '#666', fontSize: 14 }}>
                                //         No data available for the selected month and year.
                                //     </Typography>
                                // )}
                                // </Box>
                            )}

                        </Grid >
                    </Grid >
                </>
            )}
        </Box >
    );
}

export default DashboardLayout;